/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-03-27 12:07:34
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-03-27 20:21:41
 * @FilePath: /unifyxp-v2-store-portal/src/components/Antd/Input/BlurValidateInput.tsx
 */
import React from 'react';

import Input from './Input';

const BlurValidateInput = (props) => {
  const { onFocus, value, onChange, validate, ...rest } = props;

  const handleOnChange = () => {
    if (validate) validate(value);
  };
  return (
    <Input
      onFocus={onFocus}
      onChange={onChange}
      value={value}
      onBlur={handleOnChange}
      {...rest}
    />
  );
};
export default BlurValidateInput;
